<template>
  <section class="container-section">
    <div class="sub-container">
      <section class="section-titles">
        <h3 class="title">
          Logística de Recepción
        </h3>
      </section>
      <section class="list-items">
        <div class="items">
          <label style="cursor: pointer">
            <input
              v-model="receptionLogistics.merchandiseHandlingReceipt"
              name="merchandiseHandlingReceipt"
              class="uk-checkbox"
              type="checkbox"
            > Manejo de mercancía <span class="opt">(recibo)</span>
          </label>
        </div>
        <div
          v-show="transportModeTypeEnum.maritime === transportMode"
          v-if="dryLoadOff"
          style="padding-bottom: 10px"
          class="uk-flex items uk-flex-wrap"
        >
          <div class="uk-margin-right uk-flex uk-flex-column uk-flex-center">
            <label style="cursor: pointer">
              <input
                v-model="receptionLogistics.nonReeferWarerhouse"
                class="uk-checkbox"
                type="checkbox"
                @change="receptionLogistics.warerhouseDays = 0"
              > Almacenamiento carga seca
            </label>
          </div>
          <div
            class="uk-flex"
            style="margin-top: 5px"
          >
            <input
              v-model="receptionLogistics.warerhouseDays"
              :disabled="!receptionLogistics.nonReeferWarerhouse"
              min="0"
              max="9999"
              class="uk-input uk-form-width-xsmall"
              style="width: 70px; margin-right: 5px"
              type="number"
              @keydown="$helperPlugin.onlyNumber($event)"
            >
            <label class=" uk-flex uk-flex-column uk-flex-center"> No. de días</label>
          </div>
        </div>
        <div
          v-show="transportModeTypeEnum.maritime === transportMode"
          v-if="reeferdOff"
          style="padding-bottom: 10px"
          class="uk-flex items uk-flex-wrap"
        >
          <div class="uk-margin-right uk-flex uk-flex-column uk-flex-center">
            <label style="cursor: pointer">
              <input
                v-model="receptionLogistics.refrigeratedStorage"
                class="uk-checkbox"
                type="checkbox"
                @change="receptionLogistics.warerhouseDays = 0"
              > Almacenamiento refrigerado
            </label>
          </div>
          <div
            class="uk-flex"
            style="margin-top: 5px"
          >
            <input
              v-model="receptionLogistics.warerhouseDays"
              :disabled="!receptionLogistics.refrigeratedStorage"
              min="0"
              max="9999999"
              class="uk-input uk-form-width-xsmall"
              style="width: 70px; margin-right: 5px"
              type="number"
              @keydown="$helperPlugin.onlyNumber($event)"
            >
            <label class=" uk-flex uk-flex-column uk-flex-center"> No. de días</label>
          </div>
        </div>
        <div
          v-if="transportModeTypeEnum.maritime === transportMode"
          class="uk-flex uk-flex-wrap"
        >
          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="receptionLogistics.valueAddedServices"
                name="valueAddedServices"
                class="uk-checkbox"
                type="checkbox"
                tooltip="Value added services"
              > Servicio de valor añadido
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="receptionLogistics.warehouseEnvironmentTransport"
                name="warehouseEnvironmentTransport"
                class="uk-checkbox"
                type="checkbox"
              > Transporte entorno almacén
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="receptionLogistics.customsBroker"
                name="customsBroker"
                class="uk-checkbox"
                type="checkbox"
              > Agencia aduanal
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="receptionLogistics.merchandiseHandlingClearance"
                name="merchandiseHandlingClearance"
                class="uk-checkbox"
                type="checkbox"
              > Manejo de mercancía <span class="opt">(despacho)</span>
            </label>
          </div>
          <div
            v-if="receptionLogistics.isCarriageVergeConsolidation == true"
          >
            <div
              class="items"
            >
              <label class="uk-margin">
                <input
                  v-model="receptionLogistics.averageHaulingDistance"
                  class="uk-input uk-form-width-small"
                  type="number"
                  min="0"
                  max="9999999"
                  @keydown="$helperPlugin.onlyDecimal($event)"
                >
                -Km (Distancia Promedio de Acarreo)
              </label>
            </div>
            <div
              class="items"
            >
              <label>
                <input
                  v-model="receptionLogistics.TravelCarriageNecessary"
                  class="uk-input uk-form-width-small"
                  type="number"
                  min="0"
                  max="9999999"
                  @keydown="$helperPlugin.onlyNumber($event)"
                >
                -No. Viajes Acarreos Necesarios
              </label>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="btn">
      <wizard-button />
    </div>
  </section>
</template>

<script>
import { transportModeTypeEnum, dollyTypeEnum, directionTypeEnum } from '../../../../types'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      transportModeTypeEnum,
      dollyTypeEnum,
      directionTypeEnum,
      dryLoadOff: null,
      reeferdOff: null,

      receptionLogistics: {
        merchandiseHandlingReceipt: null,
        nonReeferWarerhouse: null,
        refrigeratedStorage: null,
        warerhouseDays: null,
        valueAddedServices: null,
        warehouseEnvironmentTransport: null,
        customsBroker: null,
        merchandiseHandlingClearance: null,
        TravelCarriageNecessary: null,
        averageHaulingDistance: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'receptionLogisticsStore',
      'transportMode',
      'dollyType',
      'journeyDirection'
    ])
  },
  watch: {
    receptionLogistics: {
      handler: function (newVal) {
        this.$store.commit('setReceptionLogistics', newVal)
      },
      deep: true
    },
    'receptionLogistics.warerhouseDays': function (newVal, oldVal) {
      if (this.receptionLogistics.warerhouseDays > 9999) {
        this.receptionLogistics.warerhouseDays = oldVal
      }
    }
  },
  mounted () {
    this.receptionLogistics = { ...this.receptionLogisticsStore }
    this.isDryLoad()
    this.isReefer()
  },
  methods: {
    isDryLoad () {
      if ((this.transportMode === this.transportModeTypeEnum.maritime || this.transportMode === this.transportModeTypeEnum.aerial) && this.journeyDirection === this.directionTypeEnum.import && this.dollyType === this.dollyTypeEnum.reefer) {
        this.dryLoadOff = false
      } else {
        this.dryLoadOff = true
      }
    },
    isReefer () {
      if ((this.transportMode === this.transportModeTypeEnum.maritime || this.transportMode === this.transportModeTypeEnum.aerial) && this.journeyDirection === this.directionTypeEnum.import && this.dollyType === this.dollyTypeEnum.dryLoad) {
        this.reeferdOff = false
      } else {
        this.reeferdOff = true
      }
    }
  }

}
</script>

<style scoped>
*{
  font-size: 12px;
}
p {

  margin: 10px;
}
.sub-container{
  min-height: 418px;;
}
.container-section{
  padding: 10px 40px
}
.uk-padding{
  padding-top: 5px;
  padding-right: 5px;
}
section{
  padding: 10px 10px 20px;
  width: 98%;
}

.title{
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 16px;
}

.section-titles{
  width: 85%;
  padding: 0px
}
.btn{
  padding-right:25px ;
}

.opt{
  font-size: 12px;
  color: rgb(151, 151, 151);
}

.list-items{
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  margin-right: 40px;
}

.items{
  margin: 0px 60px 30px 0px;
  min-width: 240px;
}
@media screen and (max-width: 1050px){
  .items{
  margin: 0px 10px 30px 0px;
  min-width: 260px;
}
}

@media screen and (max-width: 879px){
  .section-titles{
    width: 100%;
    padding: 0px;
  }
  .main{
    padding-top: 25px ;
  }
  .title{
    font-size: 17px;
    /* margin: 10px 0px 0px 8px; */
  }
  .container-section{
    padding: 10px 20px
  }
  .helper{
    font-size: 11px;
  }
  *{
    font-size: 12px;
    padding: 0px;
  }
  .items{
  display: inline-block;
  min-width: 260px;
}

}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;
    /* margin: 15px 0px 10px 0px; */

  }
  *{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }
  .item{
    min-width: 100px;
    width: 20%;
    margin: 5px 10px;;
  }
   .items{

  display: inline-block;
  min-width: 210px;
}
.opt{
    font-size: 10px;
  }

}
</style>
